import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import authQueries from "../src/queries/authQueries";

const FeedbackForm = () => {
    const navigate = useNavigate();
    const [propertyName, setPropertyName] = useState(''); 
    const [propertyId, setPropertyId] = useState(''); 
    const [bookingId, setBookingId] = useState(''); 
    const [bookingSource, setBookingSource] = useState(''); 
    const [guestFullName, setGuestFullName] = useState(''); 
    const [guestEmail, setEmail] = useState('');
    const location = useLocation();
    const [comment, setComment] = useState("");
    const [emailvalidator, setEmailvalidator] = useState("*");

    const { rating } = location.state || {};
  
    useEffect(() => {
      const propertyId = localStorage.getItem('propertyId');
      const bookingId = localStorage.getItem('bookingId');
      const guestFullName = localStorage.getItem('guestName');
      const bookingSource = localStorage.getItem('source');
      const propertyName = localStorage.getItem('propertyName');
      setPropertyName(propertyName);
      setBookingSource(bookingSource);
      setBookingId(bookingId);
      setPropertyId(propertyId);
      setGuestFullName(guestFullName);
    }, []);
    
    function isValidEmail(email) {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return emailRegex.test(email);
    }
    
    const handleSubmit =  async () => {
      if(guestFullName==='' || guestEmail==='') return;
      if(isValidEmail(guestEmail)==false){
        console.log("Not a valid email"); //for future testing purpose
        setEmailvalidator("*Invalid Email")
        return;
      } 
      const response = await submitReview.mutateAsync({
        propertyId: propertyId,
        bookingId:bookingId,
        guestFullName:guestFullName,
        guestEmail:guestEmail,
        origin:'QR',
        bookingSource:bookingSource,
        ratingScore:rating,
        reviewComment:comment,
      });
      console.log("Response:" + response);
      navigate('/thank-you', {
        state: { rating }
      });
    };
   
  
    const submitReview = authQueries.useSubmitReview( propertyId, (response) => {
      console.log("Response saved into DB:" + response);
    });
  
    return (
      <div style={{ position: 'relative',  height: '50vh' }}>
         <h1 className="header-name">{propertyName}</h1>
        <div className="reviews-content">
          <label className="labelText">Please enter your contact information</label><br></br><br></br>
          <div className="form-group">
            <label  className="labelText" htmlFor="guestName">Full Name(<span className="required">*</span>)</label><br></br><br></br>
            <input
              className="textbox"
              type="text"
              id="guestName"
              value={guestFullName}
              onChange={(e) => setGuestFullName(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label  className="labelText" htmlFor="email">
              Email(<span className="required">{emailvalidator}</span>)
            </label><br></br><br></br>
            <input
              className="textbox"
              type="text"
              id="email"
              value={guestEmail}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="form-group">
              <label  className="labelText" htmlFor="comment">
                Comment
              </label><br></br><br></br>
          <textarea
            id="comment"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder="Add a comment"
            className="textarea"
          />
        </div>
          <div className="button-group">
            <button onClick={() => navigate(`/review?origin=QR&propertyId=${propertyId}&bookingId=${bookingId}&guestName=${guestFullName}&source=${bookingSource}`)
} className="half-button">Cancel</button>
            <button onClick={handleSubmit} className="half-button">
              Submit
            </button>
          </div>
         
        </div>
       
      </div>
    );
  
  };
  

export default FeedbackForm;
